import { render } from "./Contactuspage.vue?vue&type=template&id=30dd29d0&scoped=true"
import script from "./Contactuspage.vue?vue&type=script&lang=js"
export * from "./Contactuspage.vue?vue&type=script&lang=js"

import "./Contactuspage.vue?vue&type=style&index=0&id=30dd29d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dd29d0"]])

export default __exports__